import { useMemo } from 'react';
import { useLogout } from '@app/utils/hooks';
import { useTokenUserData } from '@data/hooks';
import { Role } from '@data/sdk/match';
import { useAppUserStore, useOptimisticSignUpStore } from '@data/storage';

export const useHasAccess = (allowedRoles: Role[]): boolean => {
  const { user } = useAppUserStore();
  const { isAnonymous } = useTokenUserData();
  const { logout } = useLogout();
  const { isLoading } = useOptimisticSignUpStore();

  const hasRole = useMemo(
    () => allowedRoles.includes(user?.currentRole as Role),
    [allowedRoles, user?.currentRole],
  );

  if (isLoading) {
    return true;
  }

  // block access to protected pages
  // if user is anonymous or doesn't have the required role
  if (!hasRole || isAnonymous) {
    logout();
    return false;
  }

  return hasRole;
};
